
export default {
	props: {
		authService: {
			type: Object,
		},
	},
	data() {
		return {
			selectedCustomer: {},
			event: {
				show: false
			}
		};
	},
	computed: {
		shouldRenderPersistentSideMenu() {
			return this.$session.user && this.$session.user.menuVersion === "sidebar";
		},
		screenName() {
			return String(this.$route.meta.screenName || "Dashboard");
		}
	},
	methods: {
		async changeCustomer(idCustomer) {
			await this.authService.changeCustomer(idCustomer);
			await this.$router.push("/dashboard");
			this.$router.go(0);
		},
		async logout() {
			localStorage.removeItem("token");
			const currentUrl = window.location.href;
			window.location.href = `https://apps.gennera.com.br/public/#/login?url=${currentUrl}`;
		},
		home() {
			this.$router.push("/dashboard");
		}
	},
	mounted() {
		this.selectedCustomer.idCustomer = this.$session.customer.idCustomer;
		this.$emitter.on("eventEmitted", (event) => {
			this.event = event;
			setTimeout(() => {
				this.event.show = false;
			}, event.time);
		});
	}
};
